var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("GoogleMapMarker", {
    attrs: { google: _vm.google, map: _vm.map, options: _vm.options },
    on: { click: _vm.handleMarkerClick }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }